var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowDown component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowDown extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7502 2.85498C12.7502 2.44077 12.4145 2.10498 12.0002 2.10498C11.586 2.10498 11.2502 2.44077 11.2502 2.85498V19.306L3.39251 11.2755C3.10282 10.9795 2.62797 10.9743 2.33191 11.264C2.03585 11.5537 2.03069 12.0285 2.32038 12.3246L11.4642 21.6694C11.6053 21.8136 11.7986 21.8949 12.0003 21.8949C12.202 21.8949 12.3953 21.8136 12.5364 21.6694L21.6802 12.3246C21.9699 12.0285 21.9648 11.5537 21.6687 11.264C21.3726 10.9743 20.8978 10.9795 20.6081 11.2755L12.7502 19.3061V2.85498Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowDown.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowDown.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowDown.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-down') === undefined) {
    customElements.define('cat-icon-arrow-down', BlocksIconArrowDown);
}
